import { Box, Tabs, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import ProfileHeader from "../../../common/components/profile-header/profile-header-and-breadcrumbs";
import { routes } from "../../../constants/routes";
import BasicInformation from "./tabs/basic-information";
import LocationDetails from "./tabs/location-details";
import ServicePackages from "./tabs/service-packages";
import Documentation from "./tabs/documentation";
import BankInformation from "./tabs/bank-information";
import { getPreneedProfileManagementDetails } from "../../../api/preneed-section/preneed-profile-mgmt.api";

import "./profile-management-tabs.scss";

const ProfileManagementTabs: React.FC = () => {
  const breadcrumbLink = [
    {
      label: "Profile Management",
      link: routes.PRENEED_PROFILE_MGMT || "/preneed/profile-management",
      handleClick: () => { },
    },
  ];

  const preNeedDetailsStr = localStorage.getItem("preNeedDetails");
  let partnerId: string | undefined;

  if (preNeedDetailsStr) {
    try {
      const preNeedDetails = JSON.parse(preNeedDetailsStr);
      partnerId = preNeedDetails?.userId; // Adjust based on preneed details structure
    } catch (error) {
      console.error(
        "Failed to parse preNeedDetails from localStorage:",
        error,
      );
    }
  }

  const [activeTab, setActiveTab] = useState<number>(0);
  const [profileData, setProfileData] = useState<any>(null);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const fetchProfileData = async () => {
    try {
      const response = await getPreneedProfileManagementDetails();
      setProfileData(response.data.data);
      console.log("RESPONSE::", response);
    } catch (error) {
      console.error("ERROR fetching profile data:", error);
    }
  };

  useEffect(() => {
    fetchProfileData();
  }, []);

  if (!profileData) {
    return <Box className="profile-management">Loading...</Box>;
  }

  return (
    <Box className="profile-management">
      <ProfileHeader breadcrumbLink={breadcrumbLink} mode="preNeed" />

      <Box className="profile-management__tabs">
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          className="profile-management__tabs-header"
        >
          <Tab label="Basic Information" />
          <Tab label="Location & Media Details" />
          <Tab label="Service Packages" />
          <Tab label="Documentation" />
          <Tab label="Bank Information" />
        </Tabs>
      </Box>

      <Box className="profile-management__content">
        {activeTab === 0 && (
          <BasicInformation data={profileData.basic_information} refresh={fetchProfileData} />
        )}
        {activeTab === 1 && (
          <LocationDetails data={profileData.location_media_details} refresh={fetchProfileData} />
        )}
        {activeTab === 2 && (
          <ServicePackages data={profileData.service_packages || {}} refresh={fetchProfileData} />
        )}
        {activeTab === 3 && (
          <Documentation data={profileData.documents} refresh={fetchProfileData} />
        )}
        {activeTab === 4 && (
          <BankInformation data={profileData.banking_information} refresh={fetchProfileData} />
        )}
      </Box>
    </Box>
  );
};


export default ProfileManagementTabs;
